import styled from 'styled-components';
import colors from '../../../config/colors.json';
import ScreenSize from '../../../config/screenSizes.json';

export const StyledCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-radius: 8px;
    background-color:  ${colors.light};
    flex: 1;
    .title {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-size: 16px;
        color: ${colors.dark2};
        line-height: 25px;
        margin-bottom: 4px;
    }
    span {
        font-family: Poppins, Heltica, Arial, sans-serif;
        font-size: 12px;
        color: ${colors.darkGreyMidias2};
        line-height: 18px;
    }

    .content-header {
        display: flex;
        align-items: center;
        p {
          font-family: Poppins, Heltica, Arial, sans-serif;
          border-radius: 50%;
          width: 21px;
          height: 20px;
          padding: 0;
          font-size: 20px;  
          background: #fff;
          border: 2px solid #000;
          color: #000;
          text-align: center;
          margin-bottom: 0;
          justify-content: center;
          display: flex;
          align-items: center;
        }
    }
    
    @media screen and (max-width: 1919px) {
    padding: 0 0 5px 0;

    .content-header {
    
    p {
          font-family: Poppins, Heltica, Arial, sans-serif;
          border-radius: 50%;
          width: 21px;
          height: 20px;
          padding: 0;
          font-size: 20px;  
          background: #fff;
          border: 2px solid #000;
          color: #000;
          text-align: center;
          margin-bottom: 0;
          justify-content: center;
          display: flex;
          align-items: center;
        }
    }    
  }

  @media screen and (min-width: 1920px) {

    .content-header {
        p {
            width: 21px;
            height: 21px;
            font-size: 14px;  
            border: 2px solid #000;
            }
        }
  }

  @media screen and (max-width: ${ScreenSize.tablet}px) {
        font-size: 20px;
        padding: 18px 10px 18px;

        .content-header {
        p {
            width: 21px;
            height: 20px;
            font-size: 20px;  
            border: 2px solid #000;
            }
        }
    }
    @media screen and (max-width: ${ScreenSize.portrait}px) {
        padding: 18px 10px 18px;
    }

`;
